import { OnInit, } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Datastore, } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, FontWeight } from '@freelancer/ui/text';
import { InvoiceStatusApi, ProjectInvoiceMilestoneLinkedStatusesApi, } from 'api-typings/payments/payments';
import { BidCompleteStatusApi, MilestoneStatusApi, } from 'api-typings/projects/projects';
import * as Rx from 'rxjs';
import { map, take } from 'rxjs/operators';
var Reason;
(function (Reason) {
    Reason["NOT_REQUIRED"] = "My requirements have changed and I no longer require this work to be done";
    Reason["COMPLETE"] = "I am satisfied that all my project requirements have been met";
    Reason["INCOMPLETE"] = "The freelancer is unable to complete my project";
})(Reason || (Reason = {}));
var ProjectEndModalComponent = /** @class */ (function () {
    function ProjectEndModalComponent(datastore, modalRef) {
        this.datastore = datastore;
        this.modalRef = modalRef;
        this.ButtonColor = ButtonColor;
        this.ButtonSize = ButtonSize;
        this.HeadingType = HeadingType;
        this.HeadingSize = HeadingSize;
        this.FontColor = FontColor;
        this.FontWeight = FontWeight;
        this.Margin = Margin;
        this.control = new FormControl();
    }
    ProjectEndModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        var milestones$ = this.datastore
            .collection('milestones', function (query) {
            return query.where('bidId', '==', _this.bidId$);
        })
            .valueChanges();
        var invoices$ = this.datastore
            .collection('invoices', function (query) {
            return query
                .where('bidId', '==', _this.bidId$)
                .where('milestoneLinkedStatus', '==', ProjectInvoiceMilestoneLinkedStatusesApi.LINKED);
        })
            .valueChanges();
        this.options$ = this.getOptions$(milestones$, invoices$);
        this.hasOutstandingPayments$ = this.checkOutstandingPayments$(milestones$, invoices$);
    };
    ProjectEndModalComponent.prototype.handleCancel = function () {
        this.modalRef.close();
    };
    /**
     * Get options for form input. We use different copy for COMPLETE depending on
     * whether a payment has been made (project is complete) or not (project no
     * longer required).
     */
    ProjectEndModalComponent.prototype.getOptions$ = function (milestones$, invoices$) {
        var hasClearedMilestone$ = milestones$.pipe(map(function (milestones) {
            return milestones.some(function (m) { return m.status === MilestoneStatusApi.CLEARED; });
        }));
        var hasPaidInvoice$ = invoices$.pipe(map(function (invoices) { return invoices.some(function (i) { return i.status === InvoiceStatusApi.PAID; }); }));
        var hasMadePayment$ = Rx.combineLatest([
            hasClearedMilestone$,
            hasPaidInvoice$,
        ]).pipe(map(function (_a) {
            var hasClearedMilestone = _a[0], hasPaidInvoice = _a[1];
            return hasClearedMilestone || hasPaidInvoice;
        }));
        return hasMadePayment$.pipe(map(function (hasMadePayment) {
            return hasMadePayment
                ? [Reason.COMPLETE, Reason.INCOMPLETE]
                : [Reason.NOT_REQUIRED, Reason.INCOMPLETE];
        }));
    };
    /**
     * Check for outstanding payments (unreleased milestones and unpaid invoices)
     */
    ProjectEndModalComponent.prototype.checkOutstandingPayments$ = function (milestones$, invoices$) {
        var hasUnreleasedMilestones$ = milestones$.pipe(map(function (milestones) {
            return milestones.some(function (m) { return m.status !== MilestoneStatusApi.CLEARED; });
        }));
        var hasUnpaidInvoices$ = invoices$.pipe(map(function (invoices) {
            return !invoices.every(function (i) {
                return i.status === InvoiceStatusApi.PAID ||
                    i.status === InvoiceStatusApi.WITHDRAWN;
            });
        }));
        return Rx.combineLatest([
            hasUnreleasedMilestones$,
            hasUnpaidInvoices$,
        ]).pipe(map(function (_a) {
            var hasUnreleasedMilestones = _a[0], hasUnpaidInvoices = _a[1];
            return hasUnreleasedMilestones || hasUnpaidInvoices;
        }));
    };
    ProjectEndModalComponent.prototype.handleClick = function () {
        var _this = this;
        var _a;
        var bidDocument = this.datastore.document('bids', this.bidId$);
        // map from radio option value (which is the displayed copy) to appropriate bid status.
        var bidCompleteStatusOptionsMap = (_a = {},
            _a[Reason.COMPLETE] = BidCompleteStatusApi.COMPLETE,
            _a[Reason.NOT_REQUIRED] = BidCompleteStatusApi.COMPLETE,
            _a[Reason.INCOMPLETE] = BidCompleteStatusApi.INCOMPLETE,
            _a);
        var completeStatus = bidCompleteStatusOptionsMap[this.control.value];
        this.submissionPromise = bidDocument
            .valueChanges()
            .pipe(take(1))
            .toPromise()
            .then(function (bid) {
            _this.bidderId = bid.bidderId;
            return bidDocument.update({ completeStatus: completeStatus });
        })
            .then(function (bidUpdateResponse) {
            if (bidUpdateResponse.status === 'success') {
                if (completeStatus === BidCompleteStatusApi.COMPLETE) {
                    _this.modalRef.close(_this.bidderId); // complete ending
                }
                else {
                    _this.modalRef.close(false); // incomplete ending
                }
            }
            return bidUpdateResponse;
        });
    };
    return ProjectEndModalComponent;
}());
export { ProjectEndModalComponent };
